import React from "react";

const PayslipTable = ({ data }) => {
  return (
    <div
      style={{
        marginTop: "20px",
        background: "#fff",
        borderRadius: "12px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        overflow: "hidden",
      }}
    >
      {/* Title */}
      <div
        style={{
          padding: "12px 16px",
          borderBottom: "1px solid #e5e7eb",
          fontSize: "14px",
          fontWeight: 600,
          color: "#374151",
        }}
      >
        Payslip List
      </div>

      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        
        {/* Header */}
        <thead style={{ background: "#f9fafb" }}>
          <tr>
            {["Name", "Paid Amount", "Paid Date", "Paid Month", "Paid Year"].map(
              (head) => (
                <th
                  key={head}
                  style={{
                    textAlign: "left",
                    padding: "14px 16px",
                    fontSize: "13px",
                    fontWeight: 600,
                    color: "#374151",
                  }}
                >
                  {head}
                </th>
              )
            )}
          </tr>
        </thead>

        {/* Body */}
        <tbody>
          {data.map((item, index) => (
            <tr
              key={index}
              style={{
                borderTop: "1px solid #f1f5f9",
              }}
            >
              {/* Name + Avatar */}
              <td
                style={{
                  padding: "14px 16px",
                  display: "flex",
                  gap: "10px",
                  alignItems: "center",
                }}
              >
                <img
                  src={item.avatar}
                  alt="avatar"
                  style={{
                    width: "36px",
                    height: "36px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
                <div>
                  <div style={{ fontSize: "13px", fontWeight: 600 }}>
                    {item.name}
                  </div>
                  <div style={{ fontSize: "11px", color: "#6b7280" }}>
                    {item.role}
                  </div>
                </div>
              </td>

              {/* Paid Amount */}
              <td
                style={{
                  padding: "14px 16px",
                  fontSize: "13px",
                  color: "#374151",
                }}
              >
                {item.amount}
              </td>

              {/* Paid Date */}
              <td
                style={{
                  padding: "14px 16px",
                  fontSize: "13px",
                  color: "#374151",
                }}
              >
                {item.date}
              </td>

              {/* Paid Month */}
              <td
                style={{
                  padding: "14px 16px",
                  fontSize: "13px",
                  color: "#374151",
                }}
              >
                {item.month}
              </td>

              {/* Paid Year */}
              <td
                style={{
                  padding: "14px 16px",
                  fontSize: "13px",
                  color: "#374151",
                }}
              >
                {item.year}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PayslipTable;